import React from 'react';
import styles from './FormSectionHeading.module.css';

export const FormSectionHeading: React.FC<{ children: React.ReactNode }> = ({
    children,
}) => <div className={styles.text}>{children}</div>;
